import { INBOX_POLL_MS, InboxActions } from '@store/reducers/inbox'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

// The badge asks for fresh counts on entering the dashboard, on every
// workspace change, and once a minute while the dashboard stays open; the
// fetch itself is a saga on INBOX_FETCH_UNREAD
export const useInboxUnread = (workspaceId: string) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(InboxActions.fetchUnread())

    const timer = setInterval(
      () => dispatch(InboxActions.fetchUnread()),
      INBOX_POLL_MS
    )

    return () => clearInterval(timer)
  }, [workspaceId])
}
